"use client";
import { ReactLenis, useLenis } from "lenis/react";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

function SmoothScrolling({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const lenis = useLenis();

  useEffect(() => {
    if (!lenis) {
      return;
    }

    const { hash } = window.location;
    if (!hash) {
      // Ensure we jump back to the top whenever the pathname changes
      lenis.scrollTo(0, { immediate: true, force: true });
      return;
    }

    const id = decodeURIComponent(hash.substring(1));
    if (!id) {
      return;
    }

    const element = document.getElementById(id);
    if (element) {
      lenis.scrollTo(element, { offset: 0 });
    }
  }, [pathname, lenis]);

  return (
    <ReactLenis root options={{ lerp: 0.1, duration: 1.5 }}>
      {children}
    </ReactLenis>
  );
}

export default SmoothScrolling;
